<template>
  <div>
    
    <!-- Double Cards -->
    <div class="double-cards">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <div class="d-card">
              <img v-if="row.image4" :src="row.image4" class="img-fluid" :alt="row.title4" />
              <div class="dcard-footer gradient-blue">
                <div class="bg-title white-color" 
                    v-html="row.title4"
                    :style="'color:'+row.color4+' !important;white-space:break-spaces'">
                </div>
                <router-link v-if="row.button4" :to="row.redirect4" 
                  class="btn-line btn-line-white mr-5">{{ row.button4 }} 
                </router-link>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-md-6">
            <div class="d-card">
              <img v-if="row.image5" :src="row.image5" class="img-fluid" :alt="row.title5" />
              <div class="dcard-footer gradient-green">
                <div class="bg-title white-color"
                    v-html="row.title5"
                    :style="'color:'+row.color5+' !important;white-space:break-spaces'">
                </div>
                <router-link v-if="row.button5" :to="row.redirect5" 
                  class="btn-line btn-line-white mr-5">{{ row.button5 }} 
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Double Cards -->

  </div>
</template>

<script>
export default {
  name: "Section3",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
